import keys from "lodash/keys";

export const SHOW_STATUS = {
  inProgress: "IN PROGRESS",
  toApprove: "TO APPROVE",
  paymentPending: "PAYMENT PENDING",
  toExport: "READY FOR NETSUITE",
  exported: "EXPORTED TO NETSUITE",
  delivered: "DELIVERED",
  closed: "CLOSED"
};

export const STATUS = keys(SHOW_STATUS);

export const INVOICE_STATUS = {
  IN_PROGRESS: "in_progress",
  TO_APPROVE: "to_approve",
  APPROVED: "approved",
  DELIVERED: "delivered",
  CLOSED: "closed",
  APPROVED_BY_USER: "approved_by_user",
  CLOSED_BY_USER: "closed_by_user",
  PROCESSED_BY_USER: "processed_by_user",
  PROCESS_ERROR: "process_error",
  PAYMENT_PENDING: "payment_pending",
  EXPORTED: "exported",
  TO_EXPORT: "to_export"
};

export const PAYMENT_STATUS = {
  PAID: "paid",
  SUBMITTED: "submitted",
  UNPAID: "unpaid",
  NONE: "none",
  OPEN: "open",
  FAILED: "failed"
};

export const BULK_ACTIONS = {
  APPROVE: "Approve",
  APPROVE_PAY: "Approve and pay",
  APPROVE_NO_PAY: "Approve without paying",
  RETRY_PAYMENT: "Retry payment",
  SKIP_PAYMENT: "Proceed without paying",
  CLOSE: "Close",
  EXPORT: "Export",
  NETSUITE_API_EXPORT: "API export to Netsuite",
  SIMULATE_EXPORT: "Simulate export",
  VERIFY_PAYMENT: "Verify payment"
};

export const BULK_ACTIONS_BY_STATUS = {
  inProgress: [],
  toApprove: [BULK_ACTIONS.APPROVE, BULK_ACTIONS.APPROVE_NO_PAY, BULK_ACTIONS.APPROVE_PAY, BULK_ACTIONS.CLOSE],
  paymentPending: [BULK_ACTIONS.CLOSE, BULK_ACTIONS.RETRY_PAYMENT, BULK_ACTIONS.SKIP_PAYMENT, BULK_ACTIONS.SIMULATE_EXPORT],
  toExport: [BULK_ACTIONS.NETSUITE_API_EXPORT, BULK_ACTIONS.EXPORT],
  exported: [BULK_ACTIONS.EXPORT],
  delivered: [BULK_ACTIONS.EXPORT],
  closed: []
};

export const INVOICE_SERVICES = {
  INTERNAL_INVOICES: "internal_invoices"
};

export const INTERNAL_RESOURCE_TYPE = "internalInvoices";

export const IN_PROGRESS_STATUS = "inProgress";
export const TO_APPROVE_STATUS = "toApprove";
export const PAYMENT_PENDING_STATUS = "paymentPending";

export const INVOICES_PER_PAGE = 15;
